import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { EmptyState, Surface } from '@/components/flup';
import routes from '@/routes/routes.json';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-flup-canvas grid place-items-center p-6">
      <Surface padding={false} className="w-full max-w-md">
        <EmptyState
          icon={<Compass />}
          title="This page doesn't exist"
          message="The link may be out of date, or the page has moved. Your dashboard is still where you left it."
          actionLabel="Go to dashboard"
          onAction={() => navigate(routes.dashboard)}
          secondaryLabel="Manage slots"
          onSecondary={() => navigate(routes.venueManagement)}
        />
      </Surface>
    </div>
  );
};

export default NotFound;
